module.exports = __webpack_public_path__ + "76ca48b014bf922c8eff9725aba9de34.MP3";